
    import './styles.scoped.css';
    export default {
  "item-element": "awsui_item-element_93a1u_goggu_99",
  "disabled": "awsui_disabled_93a1u_goggu_111",
  "show-divider": "awsui_show-divider_93a1u_goggu_118",
  "highlighted": "awsui_highlighted_93a1u_goggu_121",
  "is-focused": "awsui_is-focused_93a1u_goggu_136",
  "menu-item": "awsui_menu-item_93a1u_goggu_141",
  "has-category-header": "awsui_has-category-header_93a1u_goggu_155",
  "icon": "awsui_icon_93a1u_goggu_159",
  "external-icon": "awsui_external-icon_93a1u_goggu_164"
};
  